import { React } from 'react';
import ServiceSection from '../../../../ServiceSection/ServiceSection';
import SatelliteText from '../../../SatelliteText/SatelliteText';
import satelliteIcon from '../../../satelliteIcon';

const CostCustomSoftware5 = props => (
    <ServiceSection noPadBottom noPadTitle singleTitle icon={satelliteIcon} {...props} page="costCustomSoftware" section="pricingModel">
        <div className='TextGroup Satellite'>
            <div className='container-custom subtitle'>
                <SatelliteText t={props.t} prefix="costCustomSoftware:pricingModel" first noPadBottom />
            </div>
        </div>
    </ServiceSection>
);

export default CostCustomSoftware5;
